import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpService } from './../services/http.service';
import { Globals } from '../models/globals.model';
import { SseService } from './sse-service';
import { Tenant } from '../models/tenant.model';
import { NotificationSubscription } from '../models/notification-subscription.model';
import { ComponentModel } from '../models/component.model';
import { Datasource } from '../models/datasource.model';
import { Subject, Subscription } from 'rxjs';
import { TenantActivityType } from '../../app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class adminService {

  apiUri: string;
  graphUri: string;

  tenantListApi = 'api/Tenant/GetTenantList?refineryId=';
  componentListApi = 'api/Component/GetComponentList?refineryId=';
  datasourceListApi = 'api/DataSource/GetDatasourceList?refineryId=';
  tenantUrl = 'api/tenant';
  masterComponentUrl = 'api/component/getMasterComponentList';
  componentUrl = 'api/component';
  dataSourceUrl = 'api/DataSource';
  dataSourceTypesUrl = 'api/datasource/getDatasourceTypes';
  resourceListApi = 'api/Tenant/GetResourceList';
  createKeyvaultApi = 'api/Tenant/CreateKeyVault?keyvaultName=';
  componentConfigurationApi = 'api/Component/GetComponentSubscription?tenantId=';
  getReourceGroupNameApi = "api/Tenant/GetResourceGroupName?keyvaultName=";
  getNotificationCategoryApi = "api/Notification/GetNotificationCategory";
  getReportSchedulerDetails = "api/Notification/GetReportSchedulerDetails";
  addNotificationSubscription = "api/Notification/AddSubscription";
  updateNotificationSubscription = "api/Notification/UpdateSubscription";
  getNotificationDetailsById = "api/Notification/GetNotificationDetailsById?subscriptionId=";  
  notificationListUrl = 'api/Notification/GetNotificationSubscription?refineryId=';
  notificationDeleteUrl = 'api/Notification/DeleteSubscription';
  getComponentStatusByTenantIdUrl = 'api/Tenant/GetComponentStatusByTenantId?tenantId=';
  deleteAdminDataByTenantIdUrl = 'api/Tenant/DeleteAdminDataByTenantId?tenantId=';

  public delTenantSelected = new Subject<any>();
  public subscription: Subscription[] = [];

  constructor(private readonly httpService: HttpService, private readonly globals: Globals, private readonly http: HttpClient,
    private readonly _zone: NgZone, private readonly _sseService: SseService) {
    this.apiUri = this.globals.config.platformAdminApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  getTenantList(refinaryId) {
    return this.http.get(this.apiUri + this.tenantListApi + refinaryId);
  }

  getComponentList(refinaryId) {
    return this.http.get(this.apiUri + this.componentListApi + refinaryId);
  }

  getDatasourceList(refinaryId) {
    return this.http.get(this.apiUri + this.datasourceListApi + refinaryId);
  }

  getNotificationSubscriptionList(refinaryId) {
    return this.http.get(this.apiUri + this.notificationListUrl + refinaryId);
  }

  deleteNotificationSubscription(id: number) {
    const params = new HttpParams().set('subscriptionId', id.toString());
    return this.http.delete<any>(this.apiUri + this.notificationDeleteUrl, { params: params });
  }

  saveTenant(tenantData: Tenant, displayMode: string) {
    if (displayMode == 'add') {
      return this.http.post<any>(this.apiUri + this.tenantUrl, tenantData);
    } else {
      return this.http.put<any>(this.apiUri + this.tenantUrl, tenantData);
    }
  }

  deleteTenant(id, keyVaultName, resourceGroup, deleteKv) {
    const params = new HttpParams().set('tenantId', id.toString())
      .set('keyVaultName', keyVaultName)
      .set('removeKv', deleteKv)
      .set('resourceGroup', resourceGroup);

    return this.http.delete<any>(this.apiUri + this.tenantUrl, { params: params });
  }
  GetResourceGroup(keyvaultName) {
     return this.http.get(this.apiUri + this.getReourceGroupNameApi + keyvaultName);
   
  }
  fetchMasterComponentList() {
    return this.http.get(this.apiUri + this.masterComponentUrl);
  }

  saveComponent(componentData: ComponentModel, displayMode: string) {
    if (displayMode == 'add') {
      return this.http.post<any>(this.apiUri + this.componentUrl, componentData);
    } else {
      return this.http.put<any>(this.apiUri + this.componentUrl, componentData);
    }
  }

  deleteComponent(id: number) {
    const params = new HttpParams().set('componentId', id.toString());
    return this.http.delete<any>(this.apiUri + this.componentUrl, { params: params });
  }

  getResourceList() {
    return this.http.get(this.apiUri + this.resourceListApi);
  }

  createKeyvault(keyvaultName: string, arrObjectIds: string[]) {
    return this.http.post(this.apiUri + this.createKeyvaultApi + keyvaultName, arrObjectIds);
  }

  saveDatasource(datasourceModel: Datasource, displayMode: string) {
    if (displayMode == 'add') {
      return this.http.post<any>(this.apiUri + this.dataSourceUrl, datasourceModel);
    } else {
      return this.http.put<any>(this.apiUri + this.dataSourceUrl, datasourceModel);
    }
  }

  deleteDatasource(id: number) {
    const params = new HttpParams().set('datasourceId', id.toString());
    return this.http.delete<any>(this.apiUri + this.dataSourceUrl, { params: params });
  }

  getDataSourceTypesList() {
    return this.http.get(this.apiUri + this.dataSourceTypesUrl);
  }

  redirectTo(url) {
    window.location.href = url;
  }

  getComponentSubscription(tenantId, masterComponentId) {
    return this.http.get(this.apiUri + this.componentConfigurationApi + tenantId + "&masterComponentId=" + masterComponentId);
  }

  getNotificationById(subscriptionId: any) {
    return this.http.get(this.apiUri + this.getNotificationDetailsById + subscriptionId);
  }

  getReportScheduler() {
    return this.http.get(this.apiUri + this.getReportSchedulerDetails);
  }

  getNotificationCategory() {
    return this.http.get(this.apiUri + this.getNotificationCategoryApi);
  }

  saveNotificationSubscription(notificationData: NotificationSubscription, displayMode: string) {
    if (displayMode == 'add') {
      return this.http.post<any>(this.apiUri + this.addNotificationSubscription, notificationData);
    } else {
      return this.http.put<any>(this.apiUri + this.updateNotificationSubscription, notificationData);
    }
  }

  getComponentStatusByTenantId(tenantId: number, activityType: TenantActivityType) {
    return this.http.get(this.apiUri + this.getComponentStatusByTenantIdUrl + tenantId + "&activityType="+ activityType);
  }

  deleteAdminDataByTenantId(tenantId: number) {
    return this.http.delete(this.apiUri + this.deleteAdminDataByTenantIdUrl + tenantId, {responseType : 'text'});
  } 

}
